import * as requestFromServer from "./UserGroupsCrud";
import { userGroupSlice, callTypes } from "./UserGroupsSlice";

const {actions} = userGroupSlice;

export const getUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getUserGroups(queryParams)
    .then(response => {
      dispatch(actions.userGroupsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllUserGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getUserGroup = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
      .getNewUserGroup()
      .then(response => {
        dispatch(actions.userGroupFetched(response.data));
      })
      .catch(error => {
        
      });
  }
  
  return requestFromServer
    .getUserGroup(id)
    .then(response => {
      dispatch(actions.userGroupFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveUserGroup = userGroup => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveUserGroup(userGroup)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteUserGroups = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteUserGroups(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanUserGroupsState = () => dispatch => {
  dispatch(actions.userGroupsStateCleaned());
}